const profileDatashape = `
email
name
surname
emailVerified
`;

export default profileDatashape;
